import React from "react";

function Videoz(){
    return <div className="container" style={{marginTop:"3%"}}>
    

    


   
    <div className="row" style={{marginTop:"3%"}}>

    <div className="col col-lg-6 left">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/mVKeioprU7Q?si=1WJAMczDUHx9HOOq" title="YouTube video player" frameborder="0"
     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>

    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/zZP9oL5gb1I?si=Qa_R1JFAR4n8cGMk" title="YouTube video player" frameborder="0"
     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/cIov6kmROns?si=zufgLRc860aLYe6N" title="YouTube video player" frameborder="0"
     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
    </div>

     <div className="row" style={{marginTop:"3%"}}>

    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/B3KmgC1_-Uo" title="YouTube video player" frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/YHNkhaPcALw?si=MMwWBhfZaqBAKsyO" title="YouTube video player" frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
    </div>
    
    <div className="row" style={{marginTop:"3%"}}>

    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/ipXP6_JUPGQ" title="YouTube video player" frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div className="col col-lg-6 center">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/xj7-txBU3SM" title="YouTube video player" frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    </div>   
    </div>;
}


export default Videoz;